/**
 * Responsavel Grupo Parceiro
 * @author Thacryba
 */
import {Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'

export class ResponsavelGrupoParceiro extends Resource {
  @ResponseSerialize(Responsavel)
  responsavelMaster: Responsavel | null = null

  @ResponseSerialize(Responsavel)
  parceiroPermitido: Responsavel | null = null

  idResponsavelMasterFk: number | null = null
  idResponsavelParceiroFk: number | null = null

  get $id() {
    if (!this.parceiroPermitido) return 0
    return this.parceiroPermitido?.$id
  }
  set $id(val) {
    if (!this.parceiroPermitido) this.parceiroPermitido = new Responsavel()
    this.parceiroPermitido.$id = val
  }
  reset() {
    this.responsavelMaster = null
    this.parceiroPermitido = null
    this.idResponsavelMasterFk = 0
    this.idResponsavelParceiroFk = 0
  }

  /**
   * Persists a new instance of ResponsavelGrupoParceiro.
   */
  async persistResponsavelGrupoParceiro() {
    return await Request.post(`/admin/responsavel-grupo-parceiro`, this)
      .name('persistResponsavelGrupoParceiro')
      .asNumber()
      .getData()
  }
}
